import Vue from 'vue'
import Vuex from 'vuex'
// import axios from 'axios' // remove comment if yu needed
import Crud from '../crud'
const model = (payload) => ({
  // columns
  id: payload.id
})
var crud = new Crud('TrackingGuides', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  trackingGuides: []
}

const mutations = {
  ...crud.mutations
}

const actions = {
  ...crud.actions
}

const getters = {
  ...crud.getters,
  trackingGuides: state => state.trackingGuides
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
